import Vue from 'vue'
import VueRouter from 'vue-router'
import { setFlag, getFlag } from '@/plugins/common'
import store from '@/store'

import { getMyUserInfo } from '@/api/user'

import Layout from '@/components/layout/index.vue'
import { Message } from 'element-ui'

Vue.use(VueRouter)

/**
 * meta : {
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
  }
*/

const routes = [
  // 登录
  {
    path: '/login',
    component: () => import('@/views/login/index.vue')
  },
  // 注册
  {
    path: '/reg',
    component: () => import('@/views/register/index.vue')
  },
  // 忘记密码
  {
    path: '/forpwd',
    component: () => import('@/views/forgotpassword/index.vue')
  },
  // 所有数据
  {
    path: '/preview',
    meta: { title: '预览数据', keepAlive: true },
    component: () => import('@/components/preview.vue')
  },

  {
    path: '/',
    name: 'Index',
    meta: { title: '加载中', keepAlive: true },
    component: () => import('@/views/loading.vue')
  },
  {
    path: '/home',
    name: 'home',
    meta: { title: '首页', keepAlive: true },
    component: () => import('@/views/home/index.vue')
  },
  // 化工冶金
  {
    path: '/hgyj',
    name: 'hgyj',
    meta: { title: '化工冶金', keepAlive: true },
    component: () => import('@/views/hgyj/index.vue'),
    redirect: '',
    children: [
      {
        path: ':id',
        name: 'hfyj',
        meta: { title: '', keepAlive: true },
        component: () => import('@/views/hgyj/hfyj.vue'),
        beforeEnter: (to, from, next) => {
          console.log(to, from, next)
          next()
        }
      }
    ]
  },
  // 特征分析
  {
    path: '/feature',
    name: 'feature',
    meta: { title: '特征分析', keepAlive: true },
    component: () => import('@/views/feature/index.vue'),
    redirect: '',
    children: [
      {
        path: ':id',
        name: 'feature',
        meta: { title: '', keepAlive: true },
        component: () => import('@/views/feature/feature.vue'),
        beforeEnter: (to, from, next) => {
          console.log(to, from, next)
          next()
        }
      }
    ]
  },
  // 数据统计
  {
    path: '/dataStatistics',
    name: 'dataStatistics',
    meta: { title: '数据统计', keepAlive: true },
    component: () => import('@/views/dataStatistics/index.vue'),
    redirect: '/dataStatistics/list',
    children: [
      {
        path: 'list',
        name: 'dataStatisticsList',
        meta: { keepAlive: true },
        component: () => import('@/views/dataStatistics/list.vue')
      }
    ]
  },

  // 数据管理
  {
    path: '/data',
    name: 'Data',
    meta: { title: '数据管理', keepAlive: true },
    component: () => import('@/views/dataAdministration/index.vue'),
    redirect: '/data/collect',
    children: [
      {
        path: 'collect',
        name: 'collect',
        meta: { title: '数据汇总', keepAlive: true },
        component: () => import('@/views/dataAdministration/collect.vue')
      },
      {
        path: 'advanced',
        name: 'Advanced',
        meta: { title: '高级检索', keepAlive: true },
        component: () => import('@/views/dataAdministration/advanced.vue')
      },
      {
        path: 'addition',
        name: 'addition',
        meta: { title: '添加数据', keepAlive: true },
        component: () => import('@/views/dataAdministration/addition.vue')
        // redirect:'addition/firstStep',
        // children:[
        //   {
        //     path:'firstStep',
        //     name:'firstStep',
        //     meta:{title:'第一步',keepAlive:true},
        //     component:()=>import("@/views/dataAdministration/components/addition/firstStep.vue"),
        //   },
        //   {
        //     path:'secondStep',
        //     name:'secondStep',
        //     meta:{title:'第二步',keepAlive:true},
        //     component:()=>import("@/views/dataAdministration/components/addition/secondStep.vue"),
        //   },
        //   {
        //     path:'thirdStep',
        //     name:'thirdStep',
        //     meta:{title:'第三步',keepAlive:true},
        //     component:()=>import("@/views/dataAdministration/components/addition/thirdStep.vue"),
        //   },
        // ]
      },
      {
        path: 'edit/:id',
        name: 'edit',
        meta: { title: '编辑数据', keepAlive: true },
        component: () => import('@/views/dataAdministration/addition.vue')
      },
      {
        path: 'extract',
        name: 'extract',
        meta: { title: '提取数据', keepAlive: true },
        component: () => import('@/views/dataAdministration/extract.vue')
      }
    ]
  },

  // 特别服务
  {
    path: '/specialService',
    name: 'specialService',
    meta: { title: '特别服务', keepAlive: true },
    component: () => import('@/views/specialService/index.vue'),
    redirect: '/specialService/serviceList',
    children: [
      {
        path: 'serviceList',
        name: 'serviceList',
        meta: { title: '服务汇总', keepAlive: true },
        component: () => import('@/views/specialService/serviceList.vue')
      },
      {
        path: 'dangerousDetection',
        name: 'dangerousDetection',
        meta: { title: '送样检测', keepAlive: true },
        component: () => import('@/views/specialService/dangerousDetection .vue')
      },
      {
        path: 'onSiteDetection',
        name: 'onSiteDetection',
        meta: { title: '现场检测', keepAlive: true },
        component: () => import('@/views/specialService/dangerousDetection .vue')
      },
      {
        path: 'technologyService',
        name: 'technologyService',
        meta: { title: '技术服务', keepAlive: true },
        component: () => import('@/views/specialService/dangerousDetection .vue')
      },
      {
        path: 'hazardousDetection',
        name: 'hazardousDetection',
        meta: { title: '危废样品申请', keepAlive: true },
        component: () => import('@/views/specialService/hazardousDetection.vue')
      },
      {
        path: 'testManager',
        name: 'testManager',
        meta: { title: '监测管理', keepAlive: true },
        component: () => import('@/views/specialService/testManager.vue')
      },
      {
        path: 'requestManager',
        name: 'requestManager',
        meta: { title: '申请管理', keepAlive: true },
        component: () => import('@/views/specialService/requestManager.vue')
      }
    ]
  },

  // 管理
  {
    path: '/aboutUs',
    name: 'aboutUs',
    meta: { title: '关于我们', keepAlive: true },
    component: () => import('@/views/setting/index.vue'),
    redirect: '',
    children: [
      {
        path: ':id',
        name: 'aboutUsDetail',
        meta: { title: '', keepAlive: true },
        component: () => import('@/views/setting/node.vue')
      }
      // {
      //   path: "scholarship",
      //   name: "settingScholarship",
      //   meta: { title: "使用条款", keepAlive: true },
      //   component: () => import("@/views/setting/scholarship.vue"),
      // },
      // {
      //   path: "website",
      //   name: "settingwebsite",
      //   meta: { title: "留言板", keepAlive: true },
      //   component: () => import("@/views/setting/website.vue"),
      // },
    ]
  },
  // 个人管理
  {
    path: '/personage',
    name: 'personage',
    meta: { title: '个人管理', keepAlive: true },
    component: () => import('@/views/personage/index.vue')
  },
  // 系统管理
  {
    path: '/system',
    name: 'system',
    meta: { title: '系统管理', keepAlive: true },
    component: () => import('@/views/system/index.vue'),
    redirect: '/system/page',
    children: [
      {
        path: 'page',
        name: 'page',
        meta: { title: '页面', keepAlive: true },
        component: () => import('@/views/system/page.vue')
      },
      {
        path: 'page_edit',
        name: 'pageEdit',
        meta: { title: '编辑页面', keepAlive: true },
        component: () => import('@/views/system/page_edit.vue')
      },
      {
        path: 'dictionary',
        name: 'dictionary',
        meta: { title: '数据字典', keepAlive: true },
        component: () => import('@/views/system/dictionary.vue')
      },
      {
        path: 'user',
        name: 'user',
        meta: { title: '用户管理', keepAlive: true },
        component: () => import('@/views/system/user.vue')
      },
      {
        path: 'authorization',
        name: 'authorization',
        meta: { title: '角色授权', keepAlive: true },
        component: () => import('@/views/system/authorization.vue')
      },
      {
        path: 'permission',
        name: 'permission',
        meta: { title: '权限管理', keepAlive: true },
        component: () => import('@/views/system/permission.vue')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const whiteList = ['/login', '/reg', '/forpwd']

router.beforeEach(async (to, from, next) => {
  const token = store.getters.getToken
  if (!token) {
    if (whiteList.includes(to.path)) {
      return next()
    } else {
      return next('/login')
    }
  }
  if (to.query.flag !== undefined) {
    setFlag(to.query.flag)
    console.log(getFlag())
  }
  if (to.meta.title) {
    document.title = process.env.VUE_APP_NAME + '-' + to.meta.title
  }
  const user = store.getters.getUser
  console.log(user)
  if (!whiteList.includes(to.path) && !user.id) {
    const res = await getMyUserInfo()
    const { role } = res.data
    if (!role || (role && role.length === 0)) {
      store.commit('deleteUser', res.data)
      Message.error('未分配用户角色')
    } else {
      next()
      store.commit('setUser', res.data)
    }
  } else {
    next()
  }
})

export default router
